<div class="config-method-summary">
  <span class="label">{{ label() }}</span>
  <span class="value">{{ methodLabel() }}</span>
  <a
    title="Change configuration method"
    class="action"
    nz-typography
    [routerLink]="['..', 'step-two-configuration-method']"
  >
    <span nz-icon nzType="swap" nzTheme="outline"></span>
    Change choice
  </a>
</div>
